import {inject} from '@angular/core';
import {NavigationService} from 'app/core/navigation/navigation.service';
import {NotificationsService} from 'app/layout/common/notifications/notifications.service';
import {ShortcutsService} from 'app/layout/common/shortcuts/shortcuts.service';
import {forkJoin, of, tap} from 'rxjs';
import {UserPreferenceService} from "./services/user-preference.service";
import {AuthService} from "./core/auth/auth.service";

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const shortcutsService = inject(ShortcutsService);
    const userPreferenceService = inject(UserPreferenceService);
    const authService = inject(AuthService);

    // If initial data has already been fetched, skip the API calls
    if (authService.initialDataFetched) {
        return of(true);
    }

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        authService.getUserInContext(),
        userPreferenceService.getAppearanceConfig(),
        navigationService.get(),
        notificationsService.getAll(),
        shortcutsService.getAll(),
    ]).pipe(
        tap(() => {
            // Set the flag to true after successful fetch
            authService.initialDataFetched = true;
        }),
    );
};
